import { render, staticRenderFns } from "./footer-pc.vue?vue&type=template&id=b8621ff8&scoped=true&"
import script from "./footer-pc.vue?vue&type=script&lang=js&"
export * from "./footer-pc.vue?vue&type=script&lang=js&"
import style0 from "./footer-pc.vue?vue&type=style&index=0&id=b8621ff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8621ff8",
  null
  
)

export default component.exports